<template>
  <div class="atlas-pages">
    <div class="enterprise-map-box">
      <div class="title-search row">
        <div class="title">企业图谱</div>
        <div @click.stop>
          <div class="search-box row">
            <input
              type="text"
              v-model="companyKey"
              placeholder="搜索公司"
              @input="searchTermsRecommend"
              @focus="onSearchInputFocus"
              @keyup.enter="onKeyUpEnter"
              @keyup.up="onKeyUp"
              @keyup.down="onKeyDown"
            />
            <i class="icon-search"></i>
          </div>
          <div
            v-if="companyKey&&isSuggestionPanelActive&&isShowNoDate&&(recommendWordList.length || recommendIssuance.length || recommendOther.length)"
            class="history-container"
          >
            <div v-if="recommendWordList.length" @mouseover="onMouseOver" @mouseout="isOnMouseOver = false">
              <ul
                class="suggestion-list"
                :class="[{ active: isSuggestionPanelActive&&recommendWordList.length&&companyKey}]"
              >
                <li
                  class="suggestion-item"
                  :class="{'checked-suggestion-item': checkedCompanyName && item.name === checkedCompanyName.name}"
                  v-for="item in recommendWordList"
                  :key="item.index"
                  @click="onSuggestionItemClick(item.id,item.name)"
                  @mouseover="mouseover"
                >
                  <a class="item-value">{{item.name}}</a>
                </li>
              </ul>
            </div>
            <div></div>
          </div>
          <div
            v-if="companyKey&&isSuggestionPanelActive&&isShowNoDate&&!recommendWordList.length&&!recommendIssuance.length&&!recommendOther.length"
            class="history-container"
          >
            <div class="none-title">没有相关公司</div>
          </div>
        </div>
      </div>
      <div class="filter-box">
        <div class="company-filter row">
          公司筛选：
          <el-checkbox-group v-model="checkedCompany">
            <el-checkbox v-for="(item,ind) in companyFilterKey" :key="ind" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="tree-view-box">
        <div class="browse-path">
          <div class="title">
            <span>浏览路径：</span>
          </div>
          <div class="path">
            <atlas-path :data="pathData"></atlas-path>
          </div>
          <div class="float-box"></div>
        </div>
        <div id="container" class="container">
          <div class="company-box" ref="conextMenuContainer" v-loading="isEvidenceLoading" v-show="isCompanyShow" @click.stop>
            <div class="company-btn">
              <div class="title row">{{viewCompany.stock_info || viewCompany.name}} <span class="close-icon" @click="isCompanyShow = false"></span></div>
              <div class="btn" @click="toNext(companyName,viewCompany)">企业图谱</div>
              <div class="btn" @click="toCorporate(companyName)">企业舆情</div>
            </div>
            <div class="content" v-if="viewPdfText">
              <div class="text-box" v-for="(v,i) in viewPdfText.pdf" :key="'pdf'+i">
                <a class="pdf-text" :href="v.pdf_url" target="_blank">{{v.pdf_name}}</a>
                <div class="pdf-img" v-for="(value,ind) in v.images" :key="ind">
                  <el-popover
                    placement="right"
                    popper-class="pdf-img-previewer"
                    trigger="hover"
                    :visible-arrow=false
                    >
                    <div class="content-container">
                      <img class="big-img" :src="value">            
                    </div>          
                    <img slot="reference" class="img fill" :src="value">
                  </el-popover>
                </div>
              </div>
              <div class="text-box" v-for="(v,i) in viewPdfText.text" :key="'text'+i">
                <div class="text">{{v.content}}</div>
                <div class="row check-detail">
                  <div class="row check-detail-date-source">
                    <div class="check-detail-date">{{v.date}}</div>
                    <div>{{v.source}}</div>
                  </div>
                  <a class="detail" :href="v.url" target="_blank">查看原文</a>
                </div>
              </div>
              <img class="no-compant-evidence" v-if="!viewPdfText.pdf.length && !viewPdfText.text.length" src="../../assets/img/no-company-evidence.svg" alt="">
              <div class="no-compant-evidence-data" v-if="!viewPdfText.pdf.length && !viewPdfText.text.length">{{noDataTip}}</div>
            </div>
          </div>

          <div class="atlas-title" v-show="company&&isShowCompany&&chartData.children.length">
            <span>{{company.name || company.id}}</span>
          </div>
          <div class="atlas-content" v-show="isShowCompany&&chartData.children.length">
            <div
              class="every-box"
              :class="[chartData.children.length===1?'only':'', item.name === '对外投资' ? 'width-box':'', item.name === '股东' ? 'width-box':'']"
              v-for="(item) in chartData.children"
              :key="item.name"
            >
              <div class="title">{{item.name}}</div>
              <div class="content">
                <div class="company-title-box" v-if="item.name==='高管'">
                  <div
                    class="company-title row"
                    v-for="(v) in item.children"
                    :key="v.name">
                    <div @click="detailFn(company.id,v,item.name,$event)">
                      <span>
                        <span v-if="v.stock_info" class="executives-name">{{v.stock_info}}</span>
                        <span v-else class="executives-name">{{v.name}}</span>
                        <span v-for="(i,idx) in v.position" :key="idx">
                          <span class="extra-info">{{i}}</span>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="company-title-box" v-else>
                  <div
                    class="company-title"
                    v-for="(v) in item.children"
                    :key="v.name">
                    <div class="company-title-ratio row">
                      <div class="every-company-text" :class="{'every-company-text-percentage': item.name === '对外投资' || item.name === '股东'}">
                        <span v-if="v.is_company&&v.stock_info&&v.name" class="every-company-text-title" @click="detailFn(company.id,v,item.name,$event)">
                          {{v.stock_info}}
                        </span>
                        <span v-if="v.is_company&&!v.stock_info&&v.name" class="every-company-text-title" @click="detailFn(company.id,v,item.name,$event)">
                          {{v.name}}
                        </span>
                        <span v-if="!v.is_company&&v.stock_info&&v.name" class="every-company-text-title-no-company">
                          {{v.stock_info}}
                        </span>
                        <span v-if="!v.is_company&&!v.stock_info&&v.name" class="every-company-text-title-no-company">
                          {{v.name}}
                        </span>
                      </div>
                      <div class="share-holding-ratio" v-if="item.name === '股东' || item.name === '对外投资'">{{ v.share_holding_ratio }}</div>
                    </div>
                    <div class="relation-time row" v-if="item.name === '客户' || item.name === '供应商'">
                      <div class="row" v-if="v.volume">
                        <div class="relation-time-margin">{{ v.relation_time }}</div>
                        <div class="relation-time-margin">{{ v.relation_sub_type | money_name }}{{ v.volume | money }}元</div>
                        占比{{ v.volume_ratio ? `${v.volume_ratio}%` : '--' }}
                      </div>
                      <div v-else-if="v.relation_time && v.comp_rel_time">
                        {{ v.relation_time }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="doing-now" v-show="chartData.children&&chartData.children.length===0">
            <img src="../../assets/img/no-data-img.svg" alt />
            <p class="tips">
              暂时没有
              <span>{{company.name}}</span> 的相关数据，正在持续补充中...
            </p>
          </div>
          <div class="doing-now" v-show="isLoading">正在加载中...</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import questionQuery from '@/rest/questionQuery';
import AtlasPath from '@/components/atlas/CheckCompanyAtlasPath';

export default {
  data() {
    return {
      path: [],
      graph: null,
      isShow: false,
      companyName: '',
      company: { id: '江苏恒瑞医药股份有限公司', name: '恒瑞医药(600276.SH)' },
      isCompanyShow: false,
      companyKey: '',
      companyFilterKey: ['上市公司', '发债主体'],
      checkedCompany: [],
      pathData: [],
      checkedRelationship: [],
      chartData: [],
      isShowNoDate: false,
      timer: null,
      recommendWordList: [],
      recommendIssuance: [],
      recommendOther: [],
      suggestionList: [],
      isSuggestionPanelActive: false,
      viewCompany: {},
      type: '',
      isShowCompany: false,
      isLoading: false,
      checkedCompanyName: null,
      checkedCompanyNameIndex: -1,
      isOnMouseOver: false,
      viewPdfText: null,
      isEvidenceLoading: false,
      noDataTip: ''
    };
  },
  components: {
    AtlasPath
  },
  watch: {
    checkedCompany() {
      this.getDate();
    }
  },
  filters: {
    money_name(val) {
      if (val === '供应商') return '采购金额';
      if (val === '客户') return '销售金额';
      return val;
    }
  },
  methods: {
    onKeyUp() {
      if (!this.isOnMouseOver) {
        if (!this.checkedCompanyNameIndex || this.checkedCompanyNameIndex === -1) {
          this.checkedCompanyNameIndex = this.recommendWordList.length - 1;
        } else {
          this.checkedCompanyNameIndex--;
        }
        this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
      }
    },
    onKeyDown() {
      if (!this.isOnMouseOver) {
        if (this.checkedCompanyNameIndex === this.recommendWordList.length - 1) {
          this.checkedCompanyNameIndex = 0;
        } else {
          this.checkedCompanyNameIndex++;
        }
        this.checkedCompanyName = this.recommendWordList[this.checkedCompanyNameIndex];
      }
    },
    onKeyUpEnter() {
      if (this.checkedCompanyName) {
        this.onSuggestionItemClick(this.checkedCompanyName.id, this.checkedCompanyName.name);
      }
    },
    onMouseOver() {
      this.checkedCompanyName = null;
      this.checkedCompanyNameIndex = -1;
      this.isOnMouseOver = true;
    },
    toCorporate(name) {
      const routeUrl = this.$router.resolve({
        path: '/result',
        query: {
          q: name
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    toNext(name, obj) {
      if (this.pathData.length) {
        this.pathData[this.pathData.length - 1].edge = this.type;
      }
      this.pathData.push({
        node: obj.stock_info,
        name: obj.name,
        edge: null
      });
      localStorage.setItem('pathData', JSON.stringify(this.pathData));
      this.company = { id: name, name: obj.stock_info };
      this.getDate();
      this.isCompanyShow = false;
    },
    detailFn(company, v, type, e) {
      if (type === '客户' || type === '供应商') {
        this.noDataTip = '关系来自公司公告';
      } else {
        this.noDataTip = '关系来自工商登记数据';
      }
      this.type = type;
      this.isCompanyShow = true;
      this.companyName = v.name;
      this.viewCompany = v;
      this.viewPdfText = null;
      this.isEvidenceLoading = true;
      questionQuery.getCompanyRefer(company, v.name, type).then(res => {
        this.isEvidenceLoading = false;
        this.viewPdfText = res;
      });
      const rect = document.documentElement.clientWidth - 400;
      let boxLeft = e.pageX - e.offsetX + 260;
      let boxTop = 400;
      if (rect < boxLeft) {
        boxLeft = rect;
      }
      if (document.documentElement.clientHeight - 260 < e.pageY) {
        if (document.documentElement.clientHeight < 640) {
          boxTop = 300;
        } else {
          boxTop = document.documentElement.clientHeight - 480;
        }
      }
      // eslint-disable-next-line
      this.$refs.conextMenuContainer.style.top = boxTop + 'px';
      // eslint-disable-next-line
      this.$refs.conextMenuContainer.style.left = boxLeft + 'px';
    },
    mouseover() {
      this.relatedActive = 'background-color: #17171b';
    },
    mouseOver() {
      this.relatedActive = 'background-color: #222227';
    },
    mouseLeave() {
      this.relatedActive = 'background-color: #17171b';
    },
    onSearchInputFocus() {
      this.isSuggestionPanelActive = true;
      this.isCompanyShow = false;
    },
    onSuggestionItemClick(value, name) {
      this.company = { id: value, name };
      this.companyKey = name;
      this.isSuggestionPanelActive = false;
      this.pathData = [
        {
          node: name,
          edge: null
        }
      ];
      localStorage.setItem('pathData', JSON.stringify(this.pathData));
      this.getDate();
      this.checkedCompanyName = null;
      this.checkedCompanyNameIndex = -1;
    },
    getDate() {
      if (this.company.id) {
        this.isShowCompany = false;
        this.isLoading = true;
        questionQuery
          .checkCompanyProfile(
            this.company.id,
            this.checkedCompany,
            this.checkedRelationship
          )
          .then(res => {
            res.types = 0;
            this.chartData = res;
            this.isShowCompany = true;
            this.isLoading = false;
            this.$nextTick(() => {
              if (document.querySelector('.atlas-content')) {
                document.querySelector('.atlas-content').scrollLeft = 0;
              }
            });
          });
      }
    },
    searchTermsRecommend() {
      this.isShowNoDate = false;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        if (this.companyKey) {
          this.searchTextRecommend();
        }
      }, 300);
    },
    async searchTextRecommend() {
      const oldSearchText = this.companyKey;
      const res = await questionQuery.searchTextRecommend(this.companyKey);
      if (oldSearchText === this.companyKey) {
        this.recommendWordList = res.company;
        this.isShowNoDate = true;
        this.isSuggestionPanelActive = true;
        this.checkedCompanyName = null;
        this.checkedCompanyNameIndex = -1;
      }
    },
    clickFn(e) {
      if (
        e.target.className === 'history-container' || e.target.className === 'history-title' || e.target.className === 'el-input__inner'
      ) {
        this.isSuggestionPanelActive = true;
      } else {
        this.isSuggestionPanelActive = false;
      }
      if (e.target.className === 'detail' || e.target.className === 'company-box' || e.target.className === 'text' || e.target.className === 'text-box' || e.target.className === 'company-btn' || e.target.className === 'title row' || e.target.className === 'every-company-text-title' || e.target.className === 'close') {
        this.isCompanyShow = true;
      } else {
        this.isCompanyShow = false;
      }
    },
    atlasContentScrollEvent() {
      this.isCompanyShow = false;
    }
  },
  created() {
    this.pathData = [];
    if (this.$route.query.label && this.$route.query.id) {
      this.company.name = this.$route.query.label;
      this.company.id = this.$route.query.id;
    }
    this.pathData.push({
      node: this.company.name,
      edge: null
    });
    this.getDate();
    localStorage.setItem('pathData', JSON.stringify(this.pathData));
  },
  mounted() {
    document.body.addEventListener('click', this.clickFn);
    document.querySelector('.atlas-content').addEventListener('scroll', this.atlasContentScrollEvent);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.clickFn);
    if (document.querySelector('.atlas-content')) {
      document.querySelector('.atlas-content').removeEventListener('scroll', this.atlasContentScrollEvent);
    }
  }
};
</script>

<style lang="scss" scoped>
.atlas-pages {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 0;
  .concern-page-header {
    justify-content: space-between;
    padding: 0 24px;
    height: 44px;
    line-height: 44px;
    width: 100%;
    color: #666666;
    background-color: #ffffff;
    font-size: 14px;
    margin-bottom: 10px;
    .tab-item {
      margin-right: 32px;
      cursor: pointer;
    }
    .tab-item-active {
      color: #45a8cc;
    }
    .concern-count {
      margin-right: 10px;
      color: #747990;
      font-size: 12px;
      .count {
        color: #45a8cc;
      }
    }
    .concern-management-btn {
      margin-top: 9px;
      height: 26px;
      width: 143px;
      padding: 0;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #464d6c;
      background-color: #f7f8fc;
      &:hover {
        color: #464d6c;
        background-color: #f7f8fc;
      }
      &:focus {
        color: #464d6c;
        background-color: #f7f8fc;
      }
      &:active {
        color: #464d6c;
        background-color: #f7f8fc;
      }
    }
  }
  .enterprise-map-box {
    width: 1200px;
    padding: 0 0 20px;
    background: #ffffff;
    .title-search {
      position: relative;
      width: 100%;
      height: 44px;
      padding: 0 24px;
      justify-content: space-between;
      box-shadow: 0px 1px 0px 0px rgba(247, 247, 250, 1);
      .title {
        width: 56px;
        height: 20px;
        font-size: 14px;
        color: rgba(23, 31, 70, 1);
        line-height: 44px;
      }
      .search-box {
        position: relative;
        /deep/ .el-input {
          width: 280px;
          height: 26px;

          border-radius: 2px;
          margin-top: 9px;
          .el-input__inner {
            height: 100%;
            border: none;
            background: rgba(247, 248, 252, 1);
            color: #747990;
            font-size: 14px;
            padding: 3px 12px;
          }
        }
        .icon-search {
          position: absolute;
          top: 15px;
          right: 6px;
          display: inline-block;
          width: 14px;
          height: 14px;
          background-image: url('../../assets/img/search3.svg');
          background-size: 100% 100%;
        }
        /deep/ .el-button {
          margin-top: 9px;
          margin-left: 10px;
          padding: 0;
          line-height: 26px;
          text-align: center;
          width: 60px;
          height: 26px;
          background: rgba(69, 168, 204, 1);
          color: #ffffff;
          border-radius: 2px;
          font-size: 14px;
        }
      }
      .history-container {
        position: absolute;
        right:24px;
        top: 34px;
        padding: 16px 0 12px;
        width: 280px;
        background-color: #ffffff;
        -webkit-box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        border: solid 1px #f7f7fa;
        border-radius: 2px;
        z-index: 900;
        .suggestion-list {
          margin: 0;
          padding-left: 0;
          font-size: 14px;
          list-style: none;
          li {
            display: flex;
            justify-content: space-between;
            padding-left: 20px;
            color: #464d6c;
            cursor: pointer;

            &:hover {
              background-color: #45a8cc;
              color: #ffffff;
            }

            .item-value {
              overflow: hidden;
              display: inline-block;
              width: 580px;
              height: 32px;
              text-overflow: ellipsis;
              white-space: nowrap;
              line-height: 32px;
            }
          }
          .checked-suggestion-item {
            background-color: #45a8cc;
            color: #ffffff;
          }
        }
        .history-title {
          padding-left: 20px;
          padding-bottom: 4px;
          font-size: 12px;
          color: #45a8cc;
        }
        .none-title {
          padding-left: 20px;
          font-size: 12px;
          line-height: 28px;
          color: #9ea1b4;
        }
        .hr-container {
          padding: 8px 16px;
          .hr {
            height: 1px;
            background-color: #d8d8d8;
            opacity: 0.1;
          }
        }
      }
    }
    .filter-box {
      position: relative;
      width: 100%;
      height: 52px;
      padding: 11px 24px;
      line-height: 30px;
      font-size: 14px;
      color: #747990;
      .clear-filter {
        position: absolute;
        right: 24px;
        top: 16px;
        width: 72px;
        height: 26px;
        background: rgba(247, 248, 252, 1);
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(70, 77, 108, 1);
        line-height: 26px;
        text-align: center;
        cursor: pointer;
      }
      .el-checkbox-group {
        margin-left: 12px;
        /deep/ .el-checkbox {
          margin-right: 16px;
        }
        /deep/ .el-checkbox__label {
          padding-left: 4px;
        }
        /deep/ .el-checkbox__label {
          color: #747990;
          font-weight: 400;
        }
      }
    }
    .tree-view-box {
      display: flex;
      flex-direction: column;
      margin: auto;
      width: 1152px;
      height: calc(100vh - 276px);
      min-height: 550px;
      border: 1px solid rgba(247, 247, 250, 1);
      padding: 8px 16px 18px 16px;
      .browse-path {
        position: relative;
        width: 100%;
        margin-left: 10px;
        .title {
          float: left;
          display: inline-block;
          color: #f7f7fa;
          font-size: 14px;
          font-weight: 400;
          color: rgba(116, 121, 144, 1);
          line-height: 20px;
          width: 70px;
          height: 46px;
          span {
            position: absolute;
            top: 0;
            padding-top: 10px;
          }
        }
        .path {
          float: right;
          font-size: 14px;
          padding-bottom: 9px;
          font-weight: 400;
          color: rgba(70, 77, 108, 1);
          line-height: 24px;
          width: 1040px;
          .div {
            position: relative;
          }
          .every-company {
            margin-right: 132px;
            color: #464d6c;
          }
          .divider {
            .relationship {
              position: absolute;
              left: 50%;
              transform: translate(0, -50%);
              top: 0;
              background: #ffffff;
              padding: 0 6px;
              display: inline;
            }
            .relationship::before {
              content: "";
              display: inline-block;
              width: 40px;
              height: 2px;
              background: #d1d2da;
            }
          }
          .div:last-child .divider {
            display: none;
          }
          .divider::after {
            position: absolute;
            right: -10px;
            top: -6px;
            content: "";
            display: inline-block;
            width: 0;
            height: 0;
            border: 7px solid transparent;
            border-left-color: #d1d2da;
          }
        }
        .float-box {
          clear: both;
        }
      }
      .container {
        flex:1;
        display: flex;
        flex-direction: column;
        width: 100%;
        text-align: center;
        .company-box {
          position: absolute;
          left: -150px;
          z-index: 10;
          padding: 10px 0;
          white-space: normal;
          list-style-type: none;
          width: 400px;
          height: 460px;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 8px 20px 0px rgba(0, 22, 144, 0.14);
          border-radius: 2px;
          display: flex;
          flex-direction: column;
          .company-btn {
            position: relative;
            width: 100%;
            padding: 10px 38px 10px 10px;
            text-align: left;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 0px 0px rgba(247, 247, 250, 1);
             .close-icon {
              position: absolute;
              top: 12px;
              right: 10px;
              display: inline-block;
              width: 20px;
              height: 20px;
              background-image: url("../../assets/img/close.svg");
              cursor: pointer;
            }
            .title {
              font-size: 14px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(69, 168, 204, 1);
              line-height: 20px;
              margin-bottom: 10px;
            }
            .btn {
              display: inline-block;
              margin-right: 10px;
              line-height: 26px;
              text-align: center;
              width: 72px;
              height: 26px;
              background: rgba(69, 168, 204, 1);
              border-radius: 2px;
              color: #ffffff;
              font-size: 14px;
              cursor: pointer;
            }
          }
          .content {
            position: relative;
            flex: 1;
            overflow: auto;
            padding: 0 10px;
            text-align: left;
            .no-compant-evidence {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: 123px;
            }
            .no-compant-evidence-data {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              top: 196px;
              color: #9ea1b4;
              font-size: 14px;
            }
            .text-box {
              padding: 16px 0;
              width: 100%;
              box-shadow: 0px 1px 0px 0px rgba(247, 247, 250, 1);
              .text {
                font-size: 14px;
                font-weight: 400;
                color: #464d6c;
                line-height: 22px;
                margin-bottom: 6px;
              }
              .check-detail {
                justify-content: space-between;
                .check-detail-date-source {
                  color: #8e92a6;
                  font-size: 12px;
                  .check-detail-date {
                    margin-right: 10px;
                  }
                }
              }
              .detail {
                height: 16px;
                font-size: 12px;
                font-weight: 600;
                color: rgba(69, 168, 204, 1);
                line-height: 16px;
                text-decoration: none;
              }
              .pdf-text {
                height: 16px;
                font-size: 12px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(69, 168, 204, 1);
                line-height: 16px;
              }
              .pdf-img {
                img {
                  max-width: 377px;
                }
              }
            }
          }
        }
        .atlas-title {
          position: relative;
          margin-bottom: 32px;
          color: #ffffff;
          border-radius: 2px;
          text-align: center;
          span {
            display: inline-block;
            padding: 8px 12px;
            height: 36px;
            border-radius: 2px;
            font-size: 14px;
            background: rgba(69, 168, 204, 1);
          }
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            top: 36px;
            width: 1px;
            height: 32px;
            background: #d1d2da;
          }
        }
        .atlas-content {
          flex: 1;
          position: relative;
          top: 0;
          padding-top: 31px;
          min-height: 400px;
          text-align: center;
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          .dividing-line {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
            display: inline-block;
            height: 1px;
            background: #d1d2da;
          }
          .every-box {
            position: relative;
            width: 304px;
            margin: 0 10px;
            display: inline-table;
            height: calc(100% - 20px);
            .title {
              height: 36px;
              line-height: 36px;
              font-size: 14px;
              text-align: center;
              color: #171f46;
              background: rgba(235, 246, 251, 1);
            }
            .content {
              line-height: 20px;
              height: 97%;
              overflow: auto;
              color: #464d6c;
              font-size: 14px;
              text-align: left;
              .company-title-box{
                padding: 10px 16px 8px;
                background: #f7f7fa;
              }
              .company-title {
                justify-content: space-between;
                white-space:normal;
                word-break:break-all;
                padding: 6px 0;
                .company-title-ratio {
                  justify-content: space-between;
                }
                .every-company-text-percentage {
                  width: 250px;
                }
                .every-company-text-title {
                  cursor: pointer;
                  &:hover {
                    color: #45a8cc;
                  }
                }
                .executives-name {
                  display: inline-block;
                  margin-right: 15px;
                  min-width: 42px;
                }
                .extra-info {
                  margin-right: 10px;
                  color: #747990;
                  font-size: 12px;
                }
                .share-holding-ratio {
                  color: #747990;
                }
                .relation-time {
                  color: #8e92a6;
                  font-size: 12px;
                }
                .relation-time-margin {
                  margin-right: 10px;
                }
              }
            }
            .content::-webkit-scrollbar {
              width: 5px;
            }
            .content::-webkit-scrollbar-track{
              background: #f7f7fa;
            }
            &::before {
              content: "";
              position: absolute;
              left: 50%;
              top: -32px;
              width: 1px;
              height: 32px;
              background: #d1d2da;
            }
            &::after {
              content: "";
              position: absolute;
              left: 0px;
              top: -32px;
              width: calc(100% + 20px);
              height: 2px;
              background: #d1d2da;
            }
          }
          .width-box {
            width: 344px;
          }
          .every-box:nth-child(2) .title {
            background: rgba(250, 238, 241, 1);
          }
          .every-box:nth-child(3) .title {
            background: rgba(237, 248, 245, 1);
          }
          .every-box:nth-child(4) .title {
            background: rgba(240, 235, 253, 1);
          }
          .every-box:nth-child(5) .title {
            background: rgba(250, 244, 238, 1);
          }
          .every-box:nth-child(6) .title {
            background: rgba(235, 244, 251, 1);
          }
          .every-box:nth-child(7) .title {
            background: rgba(250, 238, 253, 1);
          }
          .every-box:nth-child(8) .title{
            background: rgba(235, 240, 252, 1);
          }
          .every-box:nth-child(9) .title {
            background: rgba(237, 248, 245, 1);
          }
          .every-box:first-child {
            &::after {
              content: "";
              position: absolute;
              left: 50%;
              top: -32px;
              width: calc(50% + 20px);
              height: 2px;
              background: #d1d2da;
            }
          }
          .every-box:last-child {
            &::after {
              content: "";
              position: absolute;
              left: 0px;
              top: -32px;
              width: 50%;
              height: 2px;
              background: #d1d2da;
            }
          }
          .only {
            &::after {
              content: "";
              position: absolute;
              left: 0px;
              top: -32px;
              width: 50%;
              height: 0px !important;
              background: #d1d2da;
            }
          }
        }
        .doing-now {
          padding-top: 140px;
          color: rgba(116, 121, 144, 1);
          p.tips {
            margin-top: 40px;
            height: 22px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(116, 121, 144, 1);
            line-height: 22px;
            span {
              color: #45a8cc;
              text-align: center;
            }
          }
        }
      }
      .atlas-content::-webkit-scrollbar {
        height: 10px;
      }
    }
  }
}
input {
  margin-top: 9px;
  width: 280px;
  height: 26px;
  padding: 3px 20px 3px 12px;
  font-size: 14px;
  border: solid 2px #f7f8fc;
  border-radius: 2px;
  background-color: #f7f8fc;
  outline: none;
}
input::-webkit-input-placeholder{
  color: #9ea1b4;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
  color: #9ea1b4;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
  color: #9ea1b4;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
  color: #9ea1b4;
}
</style>
<style lang="scss">
.el-tooltip__popper.is-light.atlas-tips {
  width: 400px;
  height: 420px;
  overflow: auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1) !important;
  border-radius: 2px;
  border: none;
}
.el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow::after {
  content: "";
  display: none;
  background: rgba(255, 255, 255, 0);
}
.el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow {
  border: none;
}
.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow::after {
  content: "";
  display: none;
  background: rgba(255, 255, 255, 0);
}
.el-tooltip__popper.is-light[x-placement^="left"] .popper__arrow {
  border: none;
}

.el-popover.pdf-img-previewer {
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
  .content-container {
    .big-img {
      display: block;
      margin: 0 auto;
      max-width: 700px !important;
      max-height: 399px !important;
    }
  }
}
</style>
